export default __webpack_public_path__ + "static/media/icon_drills_round.6d79d51e.png";